import React from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space, Row, Col, InputNumber } from 'antd';
import { FactorPropertyEnum } from '../emissionProperty';
import styles from '../index.module.scss';

const FormItem = Form.Item;

const Mcf: React.FC = () => (
  <div className={styles.dynamicForm}>
    <Form.List name={['factorDetails']}>
      {(fields, { add, remove }) => (
        <Space direction="vertical" style={{ width: '100%' }}>
          {fields.map(({ name, ...restField }) => {
            return (
              <Row gutter={16} key={name}>
                <Col span={8}>
                  <FormItem
                    name={[name, `${FactorPropertyEnum.MCFApproach}`]}
                    label={name === 0 ? '处理方法' : ''}
                    rules={[{ required: true }, { max: 50, message: '长度不能大于50个字符' }]}
                  >
                    <Input placeholder="请输入" />
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem
                    name={[name, `${FactorPropertyEnum.MCFValue}`]}
                    label={name === 0 ? 'MCF值' : ''}
                    rules={[{ required: true }]}
                  >
                    <InputNumber placeholder="请输入数值" style={{ width: '100%' }} min={0} />
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem
                    {...restField}
                    name={[name, `${FactorPropertyEnum.MCFRange}`]}
                    label={name === 0 ? '范围' : ''}
                    rules={[{ max: 50, message: '长度不能大于50个字符' }]}
                  >
                    <Input placeholder="请输入" />
                  </FormItem>
                </Col>
                <Col span={7}>
                  <FormItem
                    {...restField}
                    name={[name, `${FactorPropertyEnum.MCFRemark}`]}
                    label={name === 0 ? '备注' : ''}
                    rules={[{ max: 50, message: '长度不能大于50个字符' }]}
                  >
                    <Input placeholder="请输入" />
                  </FormItem>
                </Col>
                <Col span={1}>
                  <FormItem {...restField} label={name === 0 ? ' ' : ''}>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </FormItem>
                </Col>
              </Row>
            );
          })}
          <Row gutter={16}>
            <Col span={23}>
              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                新增一行
              </Button>
            </Col>
          </Row>
        </Space>
      )}
    </Form.List>
  </div>
);

export default Mcf;
